























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import UserService from "@/services/user.service";
import User from "../../models/security/user.model";
import { IdentificationType } from "@/enums/IdentificationType";
import AvatarCropper from "vue-avatar-cropper";
import { AuthResponse } from "msal";
import myMSALObj from "@/config/azure-b2c/settings";
import GenericAdd from "@/core/Generics/GenericAdd";
import MasterEducation from "@/models/curriculum/masterEducation.Model";
import UserLanguage from "@/models/curriculum/userLanguage.Model";
import CertificationUser from "@/models/curriculum/certificationUser.Model";
import PublicactionUser from "@/models/curriculum/publicactionUser.Model";
import ExperienceUser from "@/models/curriculum/experienceUser.Model";
import ContactUser from "@/models/curriculum/contactUser.Model";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import { CurriculumLevel } from "@/enums/curriculumLevel";
import { CurriculumSource } from "@/enums/curriculumSource";
import GenericEdit from "../../core/Generics/GenericEdit";
import Association from "@/models/curriculum/association.Model";
import ReferenceUser from "../../models/curriculum/referenceUser.Model";
import MaskedInput from "vue-masked-input";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import CertificactionDocument from "@/models/curriculum/certificactionDocument.Model";
import PublicationDocument from "@/models/curriculum/publicationDocument.Model";
import AcademicTitleService from "../../services/AcademicTitle.service";
import AcademicTitle from "@/models/academic/academicTitle.model";
import ScientificMagazine from "@/models/curriculum/scientificMagazine.Model";
import PeerReviewer from "@/models/curriculum/PeerReviewers.Model";
import DocoralCommittee from "@/models/curriculum/doctoralCommittee";
import DoctoralThesi from "@/models/curriculum/doctoralThesi.Model";
import Language from "@/models/language/language.model";
import { vsIcon } from "../../../vuesax";
import fileService from "@/services/file.service";
import ExternalService from "@/services/External.service";
import UserDocument from "../../models/security/userDocument.model";
import { RowTable } from "@/typings/BRowTable";
import QuillEditorJs from "@/components/quill-editor/quill-editor.vue";
import CvLoading from "@/models/cv-loading.model";
import { type } from 'jquery';
import { SAVED_CODES } from '@/enums/Codes';

@Component({
  components: {
    AvatarCropper,
    MaskedInput,
    documentcomponent: DocumentComponent,
    DatePickerComponent,
    QuillEditorJs,
  },
})
export default class Profile extends BaseVue {
  public loading: boolean = false;
  public showSaveAllModal: boolean = false;
  public carrerCodeLoading: boolean = false;
  public cvLoaders: CvLoading = new CvLoading();
  
  public model: User = new User();
  public academicTitles: Array<AcademicTitle> = [];

  public curriculumLevel = CurriculumLevel;
  public curriculumSource = CurriculumSource;

  public externalService = new ExternalService();
  public userService: UserService = new UserService();
  public academicTitleService: AcademicTitleService = new AcademicTitleService();

  public modalFiles = [];
  public contentTypeName = null;
  public showModal = false;
  public files = [];

  public getAcademicTitles() {
    this.academicTitleService.getAcademicTitle().then((response) => {
      this.academicTitles = response;
    });
  }

  public getUser() {
    this.loading = true;
    this.userService
      .getUserWithCVInfoById(this.user.id)
      .then((user) => {
        let promise = user;

        this.files = user.userDocuments.filter((x) => x.document !== null);

        promise.masterEducations.forEach((x) => {
          x.starYear = new Date(x.starYear);
          x.endYear = new Date(x.endYear);
        });

        promise.doctoralThesis.forEach((x) => {
          x.starYear = new Date(x.starYear);
          x.endYear = new Date(x.endYear);
        });

        promise.docoralCommittees.forEach((x) => {
          x.starYear = new Date(x.starYear);
          x.endYear = new Date(x.endYear);
        });

        promise.publicactionUsers.forEach((x) => {
          x.publicationYear = new Date(x.publicationYear);
        });

        promise.experienceUsers.forEach((x) => {
          x.periodStart = new Date(x.periodStart);
          x.periodEnd = new Date(x.periodEnd);
        });

        promise.certificationUsers.forEach((x) => {
          x.year = new Date(x.year);
        });

        promise.scientificMagazines.forEach((x: any) => {
          x.date = new Date(x.date);
        });

        promise.peerReviewers.forEach((x) => {
          x.date = new Date(x.date);
        });

        this.model = promise;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public redirectToRegister() {
    window.open("http://cni.mescyt.gob.do/", "_blank");
  }

  public async verDocumento(data: UserDocument) {
    if (data.document.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        data.document.id,
        data.document.originalName
      );
    else await fileService.download(data.documentId);
  }

  public async verifyCode(successNotificationIsNeeded = false) {
    if (this.model.careerCode) {
      if (await this.verifyCarrerCode()) {
        if (successNotificationIsNeeded) {
          this.operationSuccess(
            "Se comprobado que este el código de carrera le pertenece y es correcto!",
            5000
          );
        }
        return true;
      } else {
        this.operationFailed(
          "El código de carrera es incorrecto o no le pertenece!",
          5000
        );
        return false;
      }
    }
    return true;
  }

  public async verifyCarrerCode() {
    this.carrerCodeLoading = true;
    var any = await this.externalService.verifyCNIInvestigator(
      this.model.fullName,
      this.model.careerCode
    );
    this.carrerCodeLoading = false;
    return any;
  }

  public cleanQuillEditorModel(value: any) {
    return value && value.length > 0 ? value.data : null;
  }

  public invalidOperation() {
    this.$buefy.toast.open({
      queue: false,
      message: "Debe completar todos los campos para guardar la información",
      duration: 4000,
      type: "is-danger",
      position: "is-top-right",
    });
  }

  public mapBiographyModel() {
    this.model.biography = this.cleanQuillEditorModel(this.model.biographyUI);
  }

  public mounted() {
    this.getUser();
    this.getAcademicTitles();
  }

  //

  private validateMagazines(showWarning: boolean = true) {
    for (let i = 0; i < this.model.scientificMagazines.length; i++) {
      const magazine = this.model.scientificMagazines[i];
      if (!magazine.name || !magazine.date) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro editorial o revista debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public removeScientificMagazines(row: any) {
    if (row && row.id && row.id > 0) {
      this.model.scientificMagazines.forEach((scientificMagazine: any) => {
        if (scientificMagazine.id === row.id) scientificMagazine.deleted = true;
      });
    } else {
      this.model.scientificMagazines = this.model.scientificMagazines.filter(
        (x: any) => x != row
      );
    }
  }

  public addScientificMagazines() {
    if (this.validateMagazines())
      this.model.scientificMagazines.push(new ScientificMagazine());
  }

  //

  private validatePeerReviewer(showWarning: boolean = true) {
    for (let i = 0; i < this.model.peerReviewers.length; i++) {
      const peerReviewer = this.model.peerReviewers[i];
      if (
        !peerReviewer.institution ||
        !peerReviewer.evaluatedStudent ||
        !peerReviewer.date
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro par revisor debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public removesPeerReviewer(row: any) {
    if (row.id && row.id !== 0) {
      this.model.peerReviewers.forEach((peerReviewer: any) => {
        if (peerReviewer.id === row.id) peerReviewer.deleted = true;
      });
    } else
      this.model.peerReviewers = this.model.peerReviewers.filter(
        (x: any) => x != row
      );
  }

  public addPeerReviewer() {
    if (this.validatePeerReviewer())
      this.model.peerReviewers.push(new PeerReviewer());
  }

  //

  private validateComitte(showWarning: boolean = true) {
    for (let i = 0; i < this.model.docoralCommittees.length; i++) {
      const committe = this.model.docoralCommittees[i];
      if (
        !committe.institution ||
        !committe.evaluatedStudent ||
        !committe.titleProposal ||
        !committe.starYear ||
        !committe.endYear
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro comite doctoral debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addCommittee() {
    if (this.validateComitte())
      this.model.docoralCommittees.push(new DocoralCommittee());
  }

  public removeDocoralCommittees(row: any) {
    if (row.id && row.id !== 0) {
      this.model.docoralCommittees.forEach((docoralCommittee: any) => {
        if (docoralCommittee.id === row.id) docoralCommittee.deleted = true;
      });
    } else
      this.model.docoralCommittees = this.model.docoralCommittees.filter(
        (x: any) => x != row
      );
  }

  //

  private validateDoctoralThesi(showWarning: boolean = true) {
    for (let index = 0; index < this.model.doctoralThesis.length; index++) {
      const doctoral = this.model.doctoralThesis[index];
      if (
        !doctoral.institution ||
        !doctoral.evaluatedStudent ||
        !doctoral.titleProposal ||
        !doctoral.starYear ||
        !doctoral.endYear ||
        doctoral.isAdvisorOrMentor == null
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra tesis doctoral debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addDoctoralThesi() {
    if (this.validateDoctoralThesi())
      this.model.doctoralThesis.push(new DoctoralThesi());
  }

  public removeDoctoralThesi(index: number, item: any) {
    if (item.id && item.id !== 0) {
      this.model.doctoralThesis.forEach((doctoralThesi: any) => {
        if (doctoralThesi.id === item.id) {
          doctoralThesi.deleted = true;
        }
      });
    } else
      this.model.doctoralThesis = this.model.doctoralThesis.filter(
        (x: any) => x != item
      );
  }

  //

  private validateContact(showWarning: boolean = true) {
    for (let i = 0; i < this.model.contactUsers.length; i++) {
      const contactUser = this.model.contactUsers[i];
      if (contactUser.hasPhone && !contactUser.phoneNumber.length) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro contacto debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
      if (!contactUser.hasPhone && !contactUser.email.length) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro contacto debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addAddress() {
    if (this.validateContact()) this.model.contactUsers.push(new ContactUser());
  }

  public removeContact(row: any) {
    if (row.id && row.id !== 0) {
      this.model.contactUsers.forEach((contactUser: any) => {
        if (contactUser.id === row.id) contactUser.deleted = true;
      });
    } else
      this.model.contactUsers = this.model.contactUsers.filter(
        (x: any) => x != row
      );
  }

  //

  private validateEducation(showWarning: boolean = true) {
    for (let i = 0; i < this.model.masterEducations.length; i++) {
      const master = this.model.masterEducations[i];
      if (
        !master.title ||
        !master.institutionName ||
        !master.countryId ||
        !master.starYear ||
        !master.endYear ||
        !master.academicTitleId
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra educación debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addEducation() {
    if (this.validateEducation())
      this.model.masterEducations.push(new MasterEducation());
  }

  public removeEducation(item: any) {
    if (item.id && item.id !== 0) {
      this.model.masterEducations.forEach((doctoralThesi: any) => {
        if (doctoralThesi.id === item.id) {
          doctoralThesi.deleted = true;
        }
      });
    } else
      this.model.masterEducations = this.model.masterEducations.filter(
        (x: any) => x != item
      );
  }

  //

  private validateLanguage(showWarning: boolean = true) {
    for (let i = 0; i < this.model.userLanguages.length; i++) {
      const currentObj = this.model.userLanguages[i];
      if (
        !currentObj.language ||
        !currentObj.writingLevel ||
        !currentObj.readingLevel ||
        !currentObj.speechLevel
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otro idioma debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public removeLanguague(row: any) {
    if (row.id && row.id !== 0) {
      this.model.userLanguages.forEach((language: any) => {
        if (language.id === row.id) language.deleted = true;
      });
    } else
      this.model.userLanguages = this.model.userLanguages.filter(
        (x: any) => x != row
      );
  }

  public addLanguague() {
    if (this.validateLanguage())
      this.model.userLanguages.push(new UserLanguage());
  }

  //

  private validateCertification(showWarning: boolean = true) {
    for (let i = 0; i < this.model.certificationUsers.length; i++) {
      const certification = this.model.certificationUsers[i];
      if (
        !certification.year ||
        !certification.certificationDescription ||
        !certification.spelledBy
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra certificación debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addCertification() {
    if (this.validateCertification())
      this.model.certificationUsers.push(new CertificationUser());
  }

  public removeCertification(index: any, id: any = null) {
    if (id && id !== 0) {
      this.model.certificationUsers.forEach((certificacion: any) => {
        if (certificacion.id === id) certificacion.deleted = true;
      });
    } else this.model.certificationUsers.splice(index, 1);
  }

  //

  private validateAssociaction(showWarning: boolean = true) {
    for (let i = 0; i < this.model.associations.length; i++) {
      const association = this.model.associations[i];
      if (!association.organizationName || !association.typeOfMembership) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra afiliación debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addAssociaction() {
    if (this.validateAssociaction())
      this.model.associations.push(new Association());
  }

  public removeAssociation(row: any) {
    if (row.id && row.id !== 0) {
      this.model.associations.forEach((association: any) => {
        if (association.id === row.id) association.deleted = true;
      });
    } else
      this.model.associations = this.model.associations.filter(
        (x: any) => x != row
      );
  }

  //

  private validatePublication(showWarning: boolean = true) {
    for (let i = 0; i < this.model.publicactionUsers.length; i++) {
      const publicaction = this.model.publicactionUsers[i];
      if (
        !publicaction.publicationTitle ||
        !publicaction.source ||
        !publicaction.publicationYear ||
        !publicaction.url
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra publicación debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addPublication() {
    if (this.validatePublication())
      this.model.publicactionUsers.push(new PublicactionUser());
  }

  public removePublication(index: any, id: any = null) {
    if (id && id !== 0) {
      this.model.publicactionUsers.forEach((publicaction: any) => {
        if (publicaction.id === id) publicaction.deleted = true;
      });
    } else this.model.publicactionUsers.splice(index, 1);
  }

  //

  private validateExperience(showWarning: boolean = true) {
    for (let i = 0; i < this.model.experienceUsers.length; i++) {
      const experience = this.model.experienceUsers[i];
      if (
        !experience.position ||
        !experience.organization ||
        !experience.countryId ||
        !experience.periodStart ||
        (!experience.isYourActualWork && !experience.periodEnd) ||
        experience.isYourActualWork == null ||
        !experience.description
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra experiencia laboral debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addExperience() {
    if (this.validateExperience())
      this.model.experienceUsers.push(new ExperienceUser());
  }

  public removeExperience(index: any, id: any = null) {
    if (id && id !== 0) {
      this.model.experienceUsers.forEach((experience: any) => {
        if (experience.id === id) experience.deleted = true;
      });
    } else this.model.experienceUsers.splice(index, 1);
  }

  //

  private validateReference(showWarning: boolean = true) {
    for (let i = 0; i < this.model.referenceUsers.length; i++) {
      const reference = this.model.referenceUsers[i];
      if (
        !reference.fullName ||
        !reference.position ||
        !reference.organization ||
        !reference.phoneNumber
      ) {
        if (showWarning) {
          this.$buefy.toast.open({
            message:
              "Antes de agregar otra referencia debe completar todos los campos anteriores",
            queue: false,
            duration: 4000,
            type: "is-danger",
            position: "is-top-right",
          });
        }
        return false;
      }
    }
    return true;
  }

  public addReference() {
    if (this.validateReference())
      this.model.referenceUsers.push(new ReferenceUser());
  }

  public removeReference(row: any) {
    if (row.id && row.id !== 0) {
      this.model.referenceUsers.forEach((referenceUser: any) => {
        if (referenceUser.id === row.id) referenceUser.deleted = true;
      });
    } else
      this.model.referenceUsers = this.model.referenceUsers.filter(
        (x: any) => x != row
      );
  }

  //

  public removeDocument(row: UserDocument) {
    if (row && row.hasOwnProperty('id') && row.id) {
      this.model.userDocuments.forEach((currentDocs: any) => {
        if (currentDocs.id === row.id) {
          currentDocs.deleted = true;
        }
      });
      this.saveSeventhBlock();
    } 
  }

  public deleteDropFile(index) {
    this.modalFiles.splice(index, 1);
  }

  public async onModalFilesChanges() {
    if (this.modalFiles) {
      this.modalFiles.forEach((currentDoc) => {
        this.files.push(currentDoc);
      });
      this.modalFiles = null;
      this.showModal = false;
      this.loading = true;
      if (this.files.length && this.files.some((x) => x.size)) {
        let docs = await fileService.uploadMany(this.files as File[]);
        docs.forEach((doc) => {
          doc.refEntityKey = "Id";
          doc.refEntityName = "UserDocument";
          doc.refEntityValue = this.user.id;
          let userDocument = new UserDocument();
          userDocument.document = doc;
          userDocument.user = this.user;
          userDocument.userId = this.user.id;
          userDocument.contentTypeName = this.contentTypeName;
          if (userDocument) {
              this.model.userDocuments.push(userDocument);
              var x = this.model.userDocuments
              console.log(this.model.userDocuments);
          }
        });
      }
      this.loading = false;
      this.saveSeventhBlock();
    }
  }

  //

  // METODOS PARA GUARDAR DATA

  public saveFirstBlock(showWarning: boolean = true) {
    this.mapBiographyModel();
    let entityDto = {
      id: this.model.id,
      hasCarrerCode: this.model.hasCarrerCode,
      careerCode: this.model.careerCode,
      orcid: this.model.orcid,
      personalPhoneNumber: this.model.personalPhoneNumber,
      biography: this.model.biography,
    };
    this.loading = true;
    
    this.userService
      .updateCVBlock(entityDto, "UpdateFirstCVBlock")
      .then((response) => {
        if (response) {
          this.loading = false;
          if (showWarning)
            this.operationSuccess();
          this.cvLoaders.firstBlock = false;
          this.cvLoaders.firstCompleted = true;
        }
      })
      .catch((error) => this.operationFailed(error));
  }

  public saveSecondBlock(showWarning: boolean = true) {
    if (this.validateContact(false)) {
      let entityDto = {
        id: this.model.id,
        contactUsers: this.model.contactUsers,
      };
      this.loading = true;
      this.userService
        .updateCVBlock(entityDto, "UpdateSecondCVBlock")
        .then((response: User) => {
          if (response) {
            this.model.contactUsers = response.contactUsers;
            this.loading = false;
            if (showWarning)
              this.operationSuccess();
            this.cvLoaders.secondBlock = false;
            this.cvLoaders.secondCompleted = true;
          }
        })
        .catch((error) => this.operationFailed(error));
    } else {
      this.invalidOperation();
      this.cvLoaders.secondBlock = false;
      this.cvLoaders.secondCompleted = false;
    }
  }

  public saveThirdBlock(showWarning: boolean = true) {
    if (
      this.validateMagazines(false) &&
      this.validatePeerReviewer(false) &&
      this.validateComitte(false) &&
      this.validateDoctoralThesi(false)
    ) {
      let entityDto = {
        id: this.model.id,
        isEditorialMember: this.model.isEditorialMember,
        scientificMagazines: this.model.scientificMagazines,
        isPeerReviewer: this.model.isPeerReviewer,
        peerReviewers: this.model.peerReviewers,
        isDoctoralCommittee: this.model.isDoctoralCommittee,
        docoralCommittees: this.model.docoralCommittees,
        isDoctoralThesi: this.model.isDoctoralThesi,
        doctoralThesis: this.model.doctoralThesis,
      };
      this.loading = true;
      this.userService
        .updateCVBlock(entityDto, "UpdateThirdCVBlock")
        .then((response: User) => {
          if (response) {
            response.scientificMagazines.forEach((x: any) => {
              x.date = new Date(x.date);
            });
            response.peerReviewers.forEach((x) => {
              x.date = new Date(x.date);
            });
            response.doctoralThesis.forEach((x) => {
              x.starYear = new Date(x.starYear);
              x.endYear = new Date(x.endYear);
            });
            response.docoralCommittees.forEach((x) => {
              x.starYear = new Date(x.starYear);
              x.endYear = new Date(x.endYear);
            });
            this.model.scientificMagazines = response.scientificMagazines;
            this.model.peerReviewers = response.peerReviewers;
            this.model.docoralCommittees = response.docoralCommittees;
            this.model.doctoralThesis = response.doctoralThesis;
            this.loading = false;
            if (showWarning)
              this.operationSuccess();
            this.cvLoaders.thirdBlock = false;
            this.cvLoaders.thirdCompleted = true;
          }
        })
        .catch((error) => this.operationFailed(error));
    } else {
      this.invalidOperation();
      this.cvLoaders.thirdBlock = false;
      this.cvLoaders.thirdCompleted = false;
    }
  }

  public saveFourthBlock(showWarning: boolean = true) {
    if (this.validateLanguage(false) && this.validateEducation(false)) {
      let entityDto = {
        id: this.model.id,
        userLanguages: this.model.userLanguages,
        masterEducations: this.model.masterEducations,
      };
      this.loading = true;
      this.userService
        .updateCVBlock(entityDto, "UpdateFourthCVBlock")
        .then((response: User) => {
          if (response) {
            response.masterEducations.forEach((x) => {
              x.starYear = new Date(x.starYear);
              x.endYear = new Date(x.endYear);
            });

            this.model.userLanguages = response.userLanguages;
            this.model.masterEducations = response.masterEducations;
            this.loading = false;
            if (showWarning)
              this.operationSuccess();
            this.cvLoaders.fourthBlock = false;
            this.cvLoaders.fourthCompleted = true;
          }
        })
        .catch((error) => this.operationFailed(error));
    } else {
      this.invalidOperation();
      this.cvLoaders.fourthBlock = false;
      this.cvLoaders.fourthCompleted = false;
    }
  }

  public saveFifthBlock(showWarning: boolean = true) {
    if (
      this.validateAssociaction(false) &&
      this.validateCertification(false) &&
      this.validatePublication(false)
    ) {
      let entityDto = {
        id: this.model.id,
        associations: this.model.associations,
        certificationUsers: this.model.certificationUsers,
        publicactionUsers: this.model.publicactionUsers,
      };
      this.loading = true;
      this.userService
        .updateCVBlock(entityDto, "UpdateFifthCVBlock")
        .then((response: User) => {
          if (response) {
            response.certificationUsers.forEach((x) => {
              x.year = new Date(x.year);
            });
            response.publicactionUsers.forEach((x) => {
              x.publicationYear = new Date(x.publicationYear);
            });
            this.model.associations = response.associations;
            this.model.certificationUsers = response.certificationUsers;
            this.model.publicactionUsers = response.publicactionUsers;
            this.loading = false;
            if (showWarning)
              this.operationSuccess();
            this.cvLoaders.fifthBlock = false;
            this.cvLoaders.fifthCompleted = true;
          }
        })
        .catch((error) => this.operationFailed(error));
    } else {
      this.invalidOperation();
      this.cvLoaders.fifthBlock = false;
      this.cvLoaders.fifthCompleted = false;
    }
  }

  public saveSixthBlock(showWarning: boolean = true) {
    if (this.validateReference(false) && this.validateExperience(false)) {
      let entityDto = {
        id: this.model.id,
        referenceUsers: this.model.referenceUsers,
        experienceUsers: this.model.experienceUsers,
      };
      this.loading = true;
      this.userService
        .updateCVBlock(entityDto, "UpdateSixthCVBlock")
        .then((response: User) => {
          if (response) {
            response.experienceUsers.forEach((x) => {
              x.periodStart = new Date(x.periodStart);
              x.periodEnd = new Date(x.periodEnd);
            });
            this.model.referenceUsers = response.referenceUsers;
            this.model.experienceUsers = response.experienceUsers;
            this.loading = false;
            if (showWarning)
              this.operationSuccess();
            this.cvLoaders.sixthBlock = false;
            this.cvLoaders.sixthCompleted = true;
          }
        })
        .catch((error) => this.operationFailed(error));
    } else {
      this.invalidOperation();
      this.cvLoaders.sixthBlock = false;
      this.cvLoaders.sixthCompleted = false;
    }
  }

  public saveSeventhBlock() {
    let entityDto = {
      id: this.model.id,
      userDocuments: this.model.userDocuments
    };
    this.loading = true;
    this.userService
      .updateCVBlock(entityDto, "UpdateSeventhCVBlock")
      .then((response: User) => {
        if (response) {
          this.model.userDocuments = response.userDocuments;
          this.files = response.userDocuments.filter((x) => x.document !== null);
          this.loading = false;
          this.operationSuccess();
        }
      }).catch((error) => this.operationFailed(error));
  }
  
  get disabledExitBotton() {
    return !this.cvLoaders.firstBlock && !this.cvLoaders.secondBlock && !this.cvLoaders.thirdBlock && !this.cvLoaders.fourthBlock && !this.cvLoaders.fifthBlock && !this.cvLoaders.sixthBlock ? false : true;
  }

  public async save() {
    this.cvLoaders.init();
    this.showSaveAllModal = true;
    await this.saveFirstBlock(false);
    await this.saveSecondBlock(false);
    await this.saveThirdBlock(false);
    await this.saveFourthBlock(false);
    await this.saveFifthBlock(false);
    await this.saveSixthBlock(false);
  }

  public resetAll() {
    if (this.cvLoaders.firstCompleted && this.cvLoaders.secondCompleted && this.cvLoaders.thirdCompleted && this.cvLoaders.fourthCompleted && this.cvLoaders.fifthCompleted && this.cvLoaders.sixthCompleted) {
      this.operationSuccess();
    } else {
      this.operationNoAllowed('Debe validar los pasos especificados');
    }

    this.showSaveAllModal = false;
    this.cvLoaders.reset();
  }
}
